var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      ref: "button",
      staticClass: "button button--primary icon--before icon--shop",
      class: {
        "cart-available": _vm.inCart !== true,
        "cart-added": _vm.inCart,
      },
      attrs: { disabled: _vm.inCart, "data-pid": _vm.entity.order_pid },
    },
    [
      _c("span", { staticClass: "cart-text--available" }, [
        _vm._v(_vm._s(_vm.labelCartBtn)),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "cart-text--added" }, [
        _vm._v(_vm._s(_vm.labelCartBtnAdded)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }